export const EVENT_DEBOUNCE_WAIT_MS = 2000;
